import { atom } from 'recoil';

export const isFullScreenAtom = atom({
  key: 'isFullScreenAtom',
  default: false,
});
